import React from "react";
import { NavLink } from "react-router-dom";

const Navbar = ({ mainPage = false }) => {
  // On the main page the navbar sits over the hero, so we lay a light
  // #e7e5e4 gradient behind it (fully opaque at the top, fading to fully
  // transparent at the bottom) to keep the dark links readable. Other pages
  // keep the original navbar untouched.
  const navClass = mainPage
    ? "text-gray-900 z-10 absolute top-0 inset-x-0 pt-6 pb-16 bg-gradient-to-b from-[#e7e5e4bf] to-[#e7e5e400]"
    : "text-gray-900 p-4 my-4 z-10 self-start max-w-4xl container mx-auto absolute";
  const innerClass = mainPage
    ? "max-w-4xl container mx-auto flex justify-between items-center px-4"
    : "max-w-4xl container mx-auto flex justify-between items-center";

  return (
    <nav className={navClass}>
      <div className={innerClass}>
        <div className="text-xl"><a href="/">Vivienne Weber</a></div>
        <div className="flex space-x-10">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive
                ? "border-b-2 border-gray-900 hover:text-gray-600"
                : "hover:text-gray-500 transition-colors duration-200"
            }
          >
            Portfolio
          </NavLink>
          <NavLink
            to="/resume"
            className={({ isActive }) =>
              isActive
                ? "border-b-2 border-gray-900 hover:text-gray-600"
                : "hover:text-gray-500 transition-colors duration-200"
            }
          >
            Resume
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
